import { createStyles, Theme } from '@material-ui/core';

const styles = ({ spacing: { unit } }: Theme) =>
  createStyles({
    divider: {
      margin: `${unit}px 0`,
      height: 2,
    },
  });

export default styles;
